/**
 *   Generated file. Do not edit
 */

import { createEnumConverter } from '@iotize/tap/service/core';
import { createEnumArrayConverter } from '@iotize/tap/service/core';
import { FixedSizeEnumConverter } from '@iotize/tap/client/impl';
import { ArrayConverter } from '@iotize/tap/client/impl';
import { EnumListConverter } from '@iotize/tap/client/impl';
import { ScramLoginParamsConverter } from './converters';
import { ScramLoginResponseBodyConverter } from './converters';
import { EncryptedIVRequestConverter } from './converters';
import { EncryptedIVResponseConverter } from './converters';

export const scramLoginParams = new ScramLoginParamsConverter();

export const scramLoginResponseBody = new ScramLoginResponseBodyConverter();

export const encryptedIVRequest = new EncryptedIVRequestConverter();

export const encryptedIVResponse = new EncryptedIVResponseConverter();
